import { useRouter } from 'next/router'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { LoginModalTypeEnum } from '../../login.enum'
import { SetLoginModalTypeProps } from '../../login.types'
import { UserOutputDto } from '../../../../../lib/graphql'
import { IconSvg } from '../../../../atoms'

export const getTitle = ({
  setModalType,
  user,
}: {
  setModalType: SetLoginModalTypeProps
  user?: Pick<UserOutputDto, 'isPasswordFilled'>
}) => {
  const router = useRouter()
  if (!user) {
    throw new Error('User is required')
  }
  return (
    <div className={s.titleWrapper}>
      <IconSvg.ArrowLeft
        onClick={() => {
          setModalType({ type: LoginModalTypeEnum.Close })
          router.back()
        }}
        className={s.icon}
      />
      <p className={s.title}>
        {!user.isPasswordFilled ? (
          <FormattedMessage
            id='ui.subscribeFinalizedModal.getTitle.finalize'
            defaultMessage='Finalisez la création de votre compte'
          />
        ) : (
          <FormattedMessage
            id='ui.subscribeFinalizedModal.getTitle.needToKnowMore'
            defaultMessage='Nous avons besoin d’en savoir plus !'
          />
        )}
      </p>
    </div>
  )
}
